import { render, staticRenderFns } from "./CheckboxSentence.vue?vue&type=template&id=e40696d2&scoped=true&"
import script from "./CheckboxSentence.vue?vue&type=script&lang=js&"
export * from "./CheckboxSentence.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSentence.vue?vue&type=style&index=0&id=e40696d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40696d2",
  null
  
)

export default component.exports